import Vue from "vue";
const ExternoEvento = new Vue();

export default ExternoEvento;
